/**
 * Username ↔ Email dönüşümü.
 *
 * Yönetici yetkili personeller için Firebase Auth altyapısı korunarak UI'da
 * "kullanıcı adı" deneyimi sağlanır. Username `nur` arka planda `nur@shiftbeat.com`
 * olarak Auth'a yazılır.
 *
 * Geri uyum: input zaten `@` içeriyorsa olduğu gibi kabul edilir (BOSS'un mevcut
 * gmail/diğer adresleri için).
 */

export const KULLANICI_DOMAIN = 'shiftbeat.com'

/** Kullanıcı adını Firebase Auth email'ine çevirir. */
export function usernameToEmail(input: string): string {
  const v = input.trim().toLowerCase()
  if (!v) return ''
  if (v.includes('@')) return v
  return `${v}@${KULLANICI_DOMAIN}`
}

/** Firebase Auth email'ini gösterilecek kullanıcı adına çevirir. */
export function emailToUsername(email: string | undefined | null): string {
  if (!email) return ''
  if (!email.includes('@')) return email
  const [local, domain] = email.toLowerCase().split('@')
  if (domain === KULLANICI_DOMAIN) return local ?? ''
  // Başka domain (örn. BOSS'un gmail'i) → tam email göster
  return email
}

const USERNAME_REGEX = /^[a-z0-9._-]{3,20}$/
const EMAIL_REGEX = /^[a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,}$/

/** Sade username formatı: 3-20 karakter, a-z, 0-9, . _ - (@'sız) */
export function isValidUsername(username: string): boolean {
  return USERNAME_REGEX.test(username.trim().toLowerCase())
}

/**
 * Login giriş alanı için geçerli mi?
 * Hem sade username (`nur`) hem de tam e-posta (`azra@gmail.com`) kabul edilir.
 */
export function isValidLoginIdentifier(input: string): boolean {
  const v = input.trim().toLowerCase()
  if (v.includes('@')) return EMAIL_REGEX.test(v)
  return USERNAME_REGEX.test(v)
}

/** Kullanıcıya hata mesajı için kural açıklaması. */
export const USERNAME_KURAL =
  'Sade kullanıcı adı (3-20 karakter, harf/rakam/. _ -) ya da geçerli bir e-posta yaz.'
